import React, { useState } from 'react';
import { Users, TrendingUp, Calendar, Target, Plus, BarChart3 } from 'lucide-react';

const MarketingDepartmentPage = () => {
  const [activeTab, setActiveTab] = useState('campaigns');

  const campaigns = [
    { id: 1, name: "Summer Sale 2025", status: "Active", budget: "R45,000", leads: 124 },
    { id: 2, name: "Email Newsletter Q2", status: "Draft", budget: "R8,500", leads: 45 },
  ];

  return (
    <div className="max-w-6xl mx-auto p-6">
      <div className="flex items-center gap-4 mb-8">
        <div className="w-16 h-16 bg-purple-100 rounded-2xl flex items-center justify-center">
          <Users size={40} className="text-purple-600" />
        </div>
        <div>
          <h1 className="text-4xl font-bold text-gray-900">Marketing Department</h1>
          <p className="text-gray-600">Campaigns • Leads • Growth</p>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex border-b mb-8 bg-white rounded-t-2xl">
        {[
          { id: 'campaigns', label: 'Campaigns', icon: Target },
          { id: 'leads', label: 'Lead Management', icon: Users },
          { id: 'calendar', label: 'Content Calendar', icon: Calendar },
          { id: 'analytics', label: 'Analytics', icon: BarChart3 },
        ].map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex-1 flex items-center justify-center gap-2 px-6 py-4 font-medium border-b-4 transition-all ${
              activeTab === tab.id 
                ? 'border-custom-orange text-custom-orange' 
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            <tab.icon size={20} />
            {tab.label}
          </button>
        ))}
      </div>

      {/* Campaigns Tab */}
      {activeTab === 'campaigns' && (
        <div className="bg-white rounded-3xl shadow p-8">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-semibold">Active Campaigns</h2>
            <button className="bg-custom-orange text-white px-6 py-3 rounded-xl flex items-center gap-2 hover:bg-orange-600">
              <Plus size={20} /> New Campaign
            </button>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {campaigns.map(campaign => (
              <div key={campaign.id} className="border rounded-2xl p-6 hover:shadow-md transition">
                <div className="flex justify-between">
                  <h3 className="font-semibold text-lg">{campaign.name}</h3>
                  <span className="px-4 py-1 bg-green-100 text-green-700 text-sm rounded-full font-medium">
                    {campaign.status}
                  </span>
                </div>
                <div className="mt-4 grid grid-cols-2 gap-4 text-sm">
                  <div>Budget: <span className="font-medium">{campaign.budget}</span></div>
                  <div>Leads: <span className="font-medium">{campaign.leads}</span></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Leads Tab */}
      {activeTab === 'leads' && (
        <div className="bg-white rounded-3xl shadow p-8">
          <h2 className="text-2xl font-semibold mb-6">Lead Management</h2>
          <div className="text-center py-16 text-gray-500">
            <Users size={60} className="mx-auto mb-4 text-gray-300" />
            <p className="text-xl">Lead tracking & CRM system coming soon</p>
          </div>
        </div>
      )}

      {/* Content Calendar */}
      {activeTab === 'calendar' && (
        <div className="bg-white rounded-3xl shadow p-8">
          <h2 className="text-2xl font-semibold mb-6">Content Calendar</h2>
          <div className="grid grid-cols-7 gap-4 text-center">
            {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map(day => (
              <div key={day} className="bg-gray-50 rounded-xl p-4">
                <p className="font-medium text-sm text-gray-500">{day}</p>
                <div className="h-20 mt-3 bg-white border rounded-lg flex items-center justify-center text-xs text-gray-400">
                  Post
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Analytics */}
      {activeTab === 'analytics' && (
        <div className="bg-white rounded-3xl shadow p-8 text-center">
          <h2 className="text-2xl font-semibold mb-6">Marketing Performance</h2>
          <div className="inline-flex items-center justify-center w-32 h-32 bg-gradient-to-br from-purple-100 to-pink-100 rounded-full mb-6">
            <BarChart3 size={60} className="text-purple-600" />
          </div>
          <p className="text-xl text-gray-600">Advanced analytics dashboard coming soon</p>
        </div>
      )}
    </div>
  );
};

export default MarketingDepartmentPage;